import { ThunkDispatch } from "redux-thunk";

import { connect } from 'react-redux';

import { NoteColor } from "../constants";

import { cancelNoteDialog, colorChanged, submitDialog, textareaChanged, Action } from '../actions';
import { getNoteDialogState, State } from '../reducers';

import NoteDialog from '../components/NoteDialogView';

interface StateProps {
    readonly color: NoteColor,
    readonly uuid: string,
    readonly open: boolean,
    readonly text: string,
}

interface DispatchProps {
    readonly onDialogCancel: () => void,
    readonly onDialogClosedFactory: (uuid: string, text: string, color: NoteColor) => () => void,
    readonly onTextareaChanged: (text: string) => void,
    readonly onColorChanged: (color: NoteColor) => void,
}

interface Props {
    readonly color: NoteColor,
    readonly open: boolean,
    readonly text: string,
    readonly onDialogCancel: () => void,
    readonly onDialogClosed: () => void,
    readonly onTextareaChanged: (text: string) => void,
    readonly onColorChanged: (color: NoteColor) => void
}


const mapStateToProps = (state: State): StateProps => {
    const dialogState = getNoteDialogState(state);
    return (
        {
            open: dialogState.open,
            uuid: dialogState.uuid,
            text: dialogState.text,
            color: dialogState.color,
        }
    );
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onDialogCancel: () => {
            dispatch(cancelNoteDialog());
        },
        onDialogClosedFactory: (uuid: string, text: string, color: NoteColor) => () => {
            dispatch(submitDialog(uuid, text, color));
        },
        onTextareaChanged: (text: string) => {
            dispatch(textareaChanged(text));
        },
        onColorChanged: (color: NoteColor) => {
            dispatch(colorChanged(color));
        }
    }
);

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): Props => (
    {
        open: stateProps.open,
        text: stateProps.text,
        color: stateProps.color,
        onDialogCancel: dispatchProps.onDialogCancel,
        onDialogClosed: dispatchProps.onDialogClosedFactory(stateProps.uuid, stateProps.text, stateProps.color),
        onTextareaChanged: dispatchProps.onTextareaChanged,
        onColorChanged: dispatchProps.onColorChanged,
    }
);


export default connect<StateProps, DispatchProps, {}, Props, State>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(NoteDialog);



// WEBPACK FOOTER //
// ./src/containers/NoteDialog.ts